import React, { useEffect, useState } from 'react';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import { useForm, UseFormRegister, FieldErrors } from 'react-hook-form';
import { AttachedFileDto, AttachedFilePermissionItemDto, AttachedFilePermissionType, AttachedFilePrivateType, AttachedFileWithPermissionsDto, UserDto, UserGroupDto } from 'models';
import { userGroupList, userList } from 'lib/api';
import * as notifications from 'lib/notifications';
import { fileUpdatePermission, getFile } from './FilesApi';
import UserDtoView from 'components/Common/UserDtoView';
import { AttachedFileUpdatePermissionsRequest } from 'models/files';
import { Card, Col, ListGroup, Row, Stack } from 'react-bootstrap';
import { CenteredSpinner } from '../Common/CenteredSpinner';
import { AddEditPermissionForm, IPermissionItemForm } from './AddEditPermissionForm';
import { getIsPrivateDescription, makeKey } from './utilities';

interface IPermissionFormProps {
    title: string;
    fileId: string;
    cancel: () => void;
    submit: (data: AttachedFileUpdatePermissionsRequest) => void;
}

export interface IPermissionTopForm {
    isPermissionInherited?: boolean | null;
    isPrivate?: AttachedFilePrivateType | null;
}
interface IPermissionTopFormProps {
    register: UseFormRegister<IPermissionTopForm>,
    errors: FieldErrors<IPermissionTopForm>,
    defaultValues: IPermissionTopForm;
    values: IPermissionTopForm;
}

function PermissionTopForm(props: IPermissionTopFormProps) {
    const register = props.register;
    const defaultValues = props.defaultValues;
    const errors = props.errors;
    const allFields = props.values;

    const isPermissionsInherited = allFields.isPermissionInherited === true;

    console.log("PermissionTopForm", allFields);

    return (
        <>
            <Row>
                <Col md={6}>
                    <Form >
                        <legend>Övergripande rättigheter</legend>

                        <Form.Group className={`mb-3 ${errors.isPermissionInherited ? 'is-invalid' : ''}`} controlId="isPermissionInherited">
                            <Form.Check
                                label="Ärvda rättigheter"
                                title='Rättigheter ärvs från överliggande mapp'
                                type="checkbox"
                                {...register('isPermissionInherited')}
                            />
                            {errors.isPermissionInherited && (
                                <Form.Control.Feedback type="invalid" className='d-block'>Detta fält är obligatoriskt.</Form.Control.Feedback>
                            )}
                            <p className="infotext">{allFields?.isPermissionInherited === true ? ("Rättigheter ärvs från överliggande objekt") : ("Rättigheter anges på detta objekt och ärvs nedåt")}</p>
                        </Form.Group>


                        {!isPermissionsInherited && (
                            <>
                                Kräv specifika rättigheter för:
                                <Form.Group className={`mb-3 ${errors.isPrivate ? 'is-invalid' : ''}`} controlId="isPrivate">

                                    <Form.Select className="mb-3" {...register('isPrivate')} >
                                        <option value={AttachedFilePrivateType.None}>Inget</option>
                                        <option value={AttachedFilePrivateType.ReadWrite}>Läs och skriv</option>
                                        <option value={AttachedFilePrivateType.WriteOnly}>Endast skriv</option>
                                    </Form.Select>

                                    {errors.isPrivate && (
                                        <Form.Control.Feedback type="invalid" className='d-block'>Detta fält är obligatoriskt.</Form.Control.Feedback>
                                    )}
                                    <p className="infotext">
                                        {getIsPrivateDescription(allFields?.isPrivate)}
                                    </p>
                                </Form.Group>
                            </>
                        )}
                    </Form>
                </Col>
            </Row>
        </>
    )
}

function sortPermissions(items: AttachedFilePermissionItemDto[]) {
    function sortF(ob1: AttachedFilePermissionItemDto, ob2: AttachedFilePermissionItemDto) {
        //console.log("ob1", ob1, "ob2", ob2);

        const ob1Type = Object.keys(AttachedFilePermissionType).indexOf(ob1.type);
        const ob2Type = Object.keys(AttachedFilePermissionType).indexOf(ob2.type);
        //console.log("types: ", ob1Type, ob2Type);

        if (ob1Type > ob2Type) {
            return -1;
        } else if (ob1Type < ob2Type) {
            return 1;
        }

        // Else go to the 2nd item
        if (ob1.userGroup && !ob2.userGroup) {
            return -1;
        } else if (ob2.userGroup && !ob1.userGroup) {
            return 1
        } else if (ob1.userGroup && ob2.userGroup) {
            return ob1.userGroup.name.localeCompare(ob2.userGroup.name);
        }

        return ob1.user.fullName.localeCompare(ob2.user.fullName);
    }
    let newItems = [...items];
    newItems.sort(sortF);
    return newItems;
}

export function PermissionForm(props: IPermissionFormProps) {
    const cancel = () => props.cancel();

    const fileId = props.fileId;
    const [file, setFile] = useState<AttachedFileWithPermissionsDto>(null);
    const [users, setUsers] = useState<UserDto[]>(null);
    const [userGroups, setUserGroups] = useState<UserGroupDto[]>(null);
    const [permissions, setPermissions] = useState<AttachedFilePermissionItemDto[]>(null);
    const [editedPermissionItem, setEditedPermissionItem] = useState<AttachedFilePermissionItemDto>(null);

    /*** Top Form ***/
    const [topFormItem, setTopFormItem] = useState<IPermissionTopForm>(null); // file ?? {isPermissionInherited: true, isPrivateReadOnly: false, isPrivateReadWrite: false}
    console.log("topFormItem", topFormItem);
    const {
        register: topFormRegister, formState: { errors: topFormErrors }, watch: topFormWatch
    } = useForm<IPermissionTopForm>({
        // defaultValues: topFormItem,
        values: topFormItem,
        resetOptions: {
            keepDirtyValues: false,
            keepErrors: false, // input errors will be retained with value update
        }
    });

    const topFormFields = topFormWatch();
    //console.log("PermissionTopForm watch allFields", topFormFields);
    const isPermissionInherited = topFormFields.isPermissionInherited;

    const save = async () => {

        const data: AttachedFileUpdatePermissionsRequest = {
            id: fileId,
            isPermissionInherited: topFormFields.isPermissionInherited === true,
            isPrivate: null,
            //isPrivate: permissions != null,
            permission: {
                items: permissions
            }
        };
        data.isPrivate = topFormFields.isPrivate;

        console.log("onSubmit");
        console.log(data);
        try {
            await fileUpdatePermission(data);
            notifications.dispatch("Rättigheterna uppdaterades", 5);
            //props.ok();
            //setFileToEdit(null);
            //refreshFileList();
        } catch (e) {
            notifications.dispatchFromError("Fel vid uppdatering av rättigheter", e, 30);
        }

        //props.submit(data);
    }

    useEffect(() => {
        if (fileId) {
            getFile(fileId).then(data => {
                setFile(data);
                setPermissions(sortPermissions(data.permissions?.items));
                setTopFormItem({
                    isPermissionInherited: data.isPermissionInherited,
                    isPrivate: data.isPrivate,
                });
            }).catch((reason) => {
                notifications.dispatchFromError("Fel vid hämtning av fil", reason, 5);
            });
            userList().then(data => {
                setUsers(data);
            }).catch((reason) => {
                notifications.dispatchFromError("Fel vid hämtning av användare", reason, 5);
            });
            userGroupList().then(data => {
                setUserGroups(data);
            }).catch((reason) => {
                notifications.dispatchFromError("Fel vid hämtning av grupper", reason, 5);
            });
        }
    }, [fileId]);

    function addOrUpdateItem(form: IPermissionItemForm) {
        let newPermissions: AttachedFilePermissionItemDto[] = [];
        if (permissions) {
            newPermissions = [...permissions];
        }

        const rawId = form.id;
        console.log("addItem() rawId:", rawId);
        const type = rawId[0];
        const id = rawId.substring(1);
        let existingItem: AttachedFilePermissionItemDto;
        if (type == "u") {
            existingItem = newPermissions.find(x => x.user?.id.toString() == id);
        }
        else if (type == "g") {
            existingItem = newPermissions.find(x => x.userGroup?.id.toString() == id);
        }

        if (existingItem == null) {
            let newItem: AttachedFilePermissionItemDto = { user: null, userGroup: null, type: AttachedFilePermissionType.ReadWrite };
            if (type == "u") {
                newItem.user = users.find(x => x.id.toString() == id);
            } else if (type == "g") {
                newItem.userGroup = userGroups.find(x => x.id.toString() == id);
            }
            newItem.type = form.type == AttachedFilePermissionType.ReadWrite.toString() ? AttachedFilePermissionType.ReadWrite : AttachedFilePermissionType.ReadOnly;
            newPermissions.push(newItem);
        } else {
            let newItem = { ...existingItem };
            newItem.type = form.type == AttachedFilePermissionType.ReadWrite.toString() ? AttachedFilePermissionType.ReadWrite : AttachedFilePermissionType.ReadOnly;
            newPermissions = newPermissions.map(x => x === existingItem ? newItem : x);
        }

        console.log(newPermissions);

        setPermissions(sortPermissions(newPermissions))
        resetForm();
    }

    function resetForm() {
        setEditedPermissionItem(null);
    }

    function removePermissionItem(item: AttachedFilePermissionItemDto) {
        if (item == editedPermissionItem) {
            resetForm();
        }
        let newPermissions = [... (permissions ?? [])];
        newPermissions = newPermissions.filter(x => x != item);
        setPermissions(sortPermissions(newPermissions));
    }

    function editItem(item: AttachedFilePermissionItemDto) {
        setEditedPermissionItem(item);
    }

    function abortItemEdit() {
        resetForm();
    }

    function addNewItem() {
        editItem({ user: null, userGroup: null, type: null });
    }

    const everythingLoaded = file && users && userGroups;

    return (
        <>

            {!everythingLoaded && <CenteredSpinner />}
            {everythingLoaded && <>
                <PermissionTopForm defaultValues={topFormItem} errors={topFormErrors} register={topFormRegister} values={topFormFields} />

                {!isPermissionInherited && (
                    <>
                        <Row>
                            <Col md={6}>
                                <Card>
                                    <Card.Header>
                                        <Stack direction='horizontal'>
                                            <div className="me-auto">
                                                <b>Specifika rättigheter</b>
                                            </div>
                                            <div className="xxxxme-3">
                                                <Button variant="secondary" onClick={addNewItem} size='sm'>Lägg till</Button>
                                            </div>
                                            {/* <div>
                                                <small>({permissions?.length})</small>
                                            </div> */}
                                        </Stack>
                                    </Card.Header>
                                    <Card.Body>
                                        <ListGroup as="ul">
                                            {permissions && permissions.map(x =>
                                                <AttachedFilePermissionItem key={makeKey(x)} item={x} editItem={editItem} removeItem={removePermissionItem} />)}
                                        </ListGroup>
                                        {permissions && permissions.length < 1 && (<>Inga specifika rättigheter angivna</>)}
                                    </Card.Body>
                                </Card>
                            </Col>
                            <Col md={6}>

                                <AddEditPermissionForm editedPermissionItem={editedPermissionItem} users={users} userGroups={userGroups} permissions={permissions}
                                    addOrUpdateItem={addOrUpdateItem} abortItemEdit={abortItemEdit}
                                />
                            </Col>
                        </Row>
                    </>
                )}
            </>
            }

            <hr />

            <Row>
                <Col md={6}>
                    <Stack direction="horizontal" gap={2}>
                        <Button variant="primary" onClick={save} className="ms-auto">
                            Spara
                        </Button>
                        <Button variant="secondary" onClick={cancel}>
                            Avbryt
                        </Button>
                    </Stack>
                </Col>
            </Row>
        </>

    );
}

function mapToString(type: AttachedFilePermissionType) {
    switch (type) {
        case AttachedFilePermissionType.ReadOnly: return "Läs"
        case AttachedFilePermissionType.ReadWrite: return "Läs/Skriv"
        case AttachedFilePermissionType.Owner: return "Ägare"
    };
}

function AttachedFilePermissionItem(props: {
    item: AttachedFilePermissionItemDto,
    editItem?: (item: AttachedFilePermissionItemDto) => void
    removeItem?: (item: AttachedFilePermissionItemDto) => void
}) {
    const x = props.item;
    return <ListGroup.Item>
        <Stack gap={2} direction="horizontal">

            <div className="ms-2 me-auto">
                <div className="fw-bold">
                    {x.user && (<><i className="bi bi-person-fill" /> <UserDtoView value={x.user} /></>)}
                    {x.userGroup && (<><i className="bi bi-people-fill" /> {x.userGroup.name} </>)}
                </div>
                {mapToString(x.type)}
            </div>

            < br />
            {props.editItem && <a href="#" onClick={(e) => { e.preventDefault(); props.editItem(x); return false; }}>Ändra</a>}
            {props.removeItem && <a href="#" onClick={(e) => { e.preventDefault(); props.removeItem(x); return false; }}>Ta bort</a>}
        </Stack>
    </ListGroup.Item>;
}


